<template>
  <div class="flex flex-col items-center justify-between px-8 py-16 md:px-16 bg-grey-light-50 w-full gap-8">
    <div class="w-full">
      <h2 class="text-3xl font-semibold mb-2 text-center">Sign up</h2>
      <p class="text-xl font-light text-gray-600 text-center">Shop over 2,000+ brands.</p>
    </div>
    <a :href="signUpUrl"> <Button size="lg" class="py-6">Sign up</Button></a>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { computed } from 'vue';
import { DASHBOARDS_URL } from '../../config';

const signUpUrl = computed((): string => {
  return `${DASHBOARDS_URL}/shopper/auth/sign-up`;
});
</script>
